import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Map } from 'immutable'
import { withTranslation } from 'react-i18next'
import { push } from 'connected-react-router'

import { scrollBodyTo } from 'store/entities/ui/actions'
import {
  isShouldShowCongratulation,
  hasAbilityToSelectNewProTrack,
  getIdentityActiveProTrackName,
  getIdentityFirstLoginFlow,
  isIdentityActiveProTrackAutoEnroll,
  isShouldShowProTrackRatingBlock,
  isStageIsSelection,
  getIdentityCanCompletePreviousActivityInWorkday,
  getIdentityLastUserActivity,
  getIdentityFirstLogin,
  isUserEverTakeProTrack,
  isProTrackStopped,
} from 'store/entities/identity/selectors'
import Dashboard from './Dashboard'
import { modal } from 'store/entities/modal/actions'
import {
  getIdentityProgress,
  getProfile,
  subscribeToProTrack,
  unsubscribeProgress,
  sendYesterdayActivity,
  activityActions,
} from 'store/entities/identity/actions'
import { getActivity, getActivityId, getActivityUserActivityId, getActionType } from 'store/entities/activity/selectors'
import {
  isShowConfirmationModalForSwitchProTrack,
  getQueries,
  isShowConfirmationModalForStopProTrack,
  isShowConfirmationModalForDifferentProTrack,
  isShowConfirmationModalForCommitPreviousActivity,
} from 'store/entities/localSettings/selectors'
import {
  setConfirmationModal,
  setConfirmationModalForStopProTrack,
  setConfirmationModalForDifferentProTrack,
  setConfirmationModalForCommitPreviousActivity,
} from 'store/entities/localSettings/actions'
import { PAUSE_BUTTONS } from 'app/constants/pauseButtons'
import { DID, COMMIT } from 'app/constants/identityActions'
import { isDateToday } from 'helpers/dateHelper'
import { SWITCH_PROTRACK_FROM_EMAIL } from 'app/constants/profile'

const mapStateToProps = createStructuredSelector({
  currentActivity: getActivity,
  activityId: getActivityId,
  userActivityId: getActivityUserActivityId,
  isShouldShowCongratulation: isShouldShowCongratulation,
  hasAbilityToSelectNewProTrack: hasAbilityToSelectNewProTrack,
  isShowConfirmationModalForSwitchProTrack,
  queries: getQueries,
  activeProTrackName: getIdentityActiveProTrackName,
  isLoginFlowFinished: getIdentityFirstLoginFlow,
  isAutoEnroll: isIdentityActiveProTrackAutoEnroll,
  isShouldShowProTrackRatingBlock,
  isStageIsSelection,
  isShowConfirmationModalForStopProTrack,
  isShowConfirmationModalForDifferentProTrack,
  isUserCanCompletePreviousActivity: getIdentityCanCompletePreviousActivityInWorkday,
  lastActivity: getIdentityLastUserActivity,
  isShowConfirmationModalForCommitPreviousActivity,
  currentActionCommitType: getActionType,
  isFirstLogin: getIdentityFirstLogin,
  getIdentityLastUserActivity,
  isUserEverTakeProTrack,
  isProTrackStopped,
})

const mapDispatchToProps = {
  scrollBodyTo,
  showModal: modal.show,
  closeModal: modal.hide,
  getIdentityProgress,
  getProfile,
  subscribeToProTrack,
  unsubscribeProgress,
  setConfirmationModal,
  setConfirmationModalForStopProTrack,
  setConfirmationModalForDifferentProTrack,
  setConfirmationModalForCommitPreviousActivity,
  sendYesterdayActivity,
  onCommit: activityActions.commit,
  goToOutOfOffice: () => push('/profile/out-of-office'),
  redirectToOnboardingLanding: () => push('/on-boarding-landing'),
}

const mergeProps = (
  {
    queries,
    lastActivity,
    currentActivity,
    activityId,
    userActivityId,
    currentActionCommitType,
    getIdentityLastUserActivity,
    ...stateProps
  },
  {
    unsubscribeProgress,
    subscribeToProTrack,
    setConfirmationModal,
    closeModal,
    setConfirmationModalForStopProTrack,
    goToOutOfOffice,
    setConfirmationModalForDifferentProTrack,
    sendYesterdayActivity,
    setConfirmationModalForCommitPreviousActivity,
    onCommit,
    ...dispatchProps
  },
  ownProps
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  setConfirmationModalForCommitPreviousActivity,
  isUserCanCommit: currentActionCommitType === null,
  committedToTodayActivity:
    isDateToday(currentActivity.get('createdAt')) && currentActivity.get('actionType') === COMMIT,
  onConfirm: () => {
    /*
      please check /identity/sagas/unsubscribeProgress
      this saga handling successful unsubscribe action
    */
    unsubscribeProgress({ data: Map(), formName: SWITCH_PROTRACK_FROM_EMAIL })
    setConfirmationModal(false)
    closeModal()
  },
  onRequestClose: () => {
    setConfirmationModal(false)
    closeModal()
  },
  onConfirmStopProTrack: state => {
    if (state === PAUSE_BUTTONS.STOP_LEVEL) {
      unsubscribeProgress({ data: Map(), formName: '' })
    } else if (state === PAUSE_BUTTONS.OUT_OF_OFFICE) {
      goToOutOfOffice()
    }
    setConfirmationModalForStopProTrack(false)
    closeModal()
  },
  onConfirmCommitPreviousActivity: () => {
    sendYesterdayActivity({
      activityId: lastActivity.get('id'),
      userActivityId: lastActivity.get('userActivityId'),
      actionType: DID,
    })
    onCommit({ activityId, userActivityId })
    setConfirmationModalForCommitPreviousActivity(false)
    closeModal()
  },
  onRequestCloseCommitPreviousActivity: () => {
    onCommit({ activityId, userActivityId })
    setConfirmationModalForCommitPreviousActivity(false)
    closeModal()
  },
  onRequestCloseStopProTrack: () => {
    setConfirmationModalForStopProTrack(false)
    closeModal()
  },
  onConfirmStopProTrackAndSelectNewProTrack: () => {
    unsubscribeProgress({ data: Map(), formName: '' })
  },
  onRequestCloseDifferentProTrack: () => {
    setConfirmationModalForDifferentProTrack(false)
    closeModal()
  },
  closeModal,
  queries,
  isYesterdayUserActivity: !!getIdentityLastUserActivity.get('userActivityId'),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withTranslation()(Dashboard))
